import React, { useEffect, useState } from "react";
import { SiMailchimp } from "react-icons/si";
import { ClassNames } from "../../../../helper";
import AuthModal from "./AuthModal";
const ConnectWithMailchimp = ({ installHandler, integrationData }) => {
  const [validAuth, setValidAuth] = useState(false);
  const [open, setOpen] = useState(false);
    const [authName, setAuthName] = useState("New authentication");

//   console.log("integrationData", integrationData);

    useEffect(() => {
        if (integrationData.data) {
            setAuthName(integrationData?.data?.accountname);
      }
  }, [integrationData]);

  return (
    <div className="my-6 text-gray-500 relative">
      {open ? (
        <div className="relative">
          <AuthModal setOpen={setOpen} />
        </div>
          ) : null}

      <div className="p-5">
        <p>
          Connect CausalFunnel with Mailchimp and automatically add new
          subscribers from the pre-chat survey and chatbots to your mailing list
          in Mailchimp.
        </p>
        <div className="my-6">
          <h3 className="text-lg font-semibold text-center my-3">
            Connect with Mailchimp account
          </h3>
          <div>
            <p>The only thing you need is the active Mailchimp account</p>
            <ol className="list-decimal list-inside">
              <li>Click the button below to add a new authorization</li>
              <li>Log in to your Mailchimp account in the popup</li>
              <li>Click the 'Allow' button</li>
            </ol>
            <div className="border-2 p-4 my-3.5" onClick={() => setOpen(true)}>
              <div className="border-2 p-2.5 flex gap-1 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                <SiMailchimp className="text-lg text-gray-800" />
                <p className="text-gray-700">{authName}</p>
              </div>
            </div>
            <p>
              We also described integration step by step in our{" "}
              <a
                href="https://www.causalfunnel.com/blog"
                target="_blank"
                rel="noreferrer noopener"
                className="text-indigo-600 hover:underline "
              >
                Knowledge base.
              </a>
            </p>
          </div>

          <hr className="my-3" />
          <div className="relative">
            <div className="space-x-4 absolute right-0">
              <button
                className="text-gray-800 hover:text-indigo-600"
                onClick={() => installHandler(false)}
              >
                Cancel
              </button>
              <button
                className={ClassNames(
                  " px-6 py-2 rounded-md",
                  validAuth
                    ? "text-white bg-indigo-600"
                    : "disabled bg-gray-200 text-gray-500 cursor-auto"
                )}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithMailchimp;
